import styled from "styled-components";
import {ProfilePictureImageDefaultBox} from "./profile-picture-image.default.box";

export const ProfilePictureImageMrGreenBox = styled(ProfilePictureImageDefaultBox)`
    width: 9rem;
    height: 9rem;
`;
